




import Vue from "vue";
export default class NotFoundPage extends Vue {}
